import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';

import classes from './AudioNode.module.scss';
import { PlayerBase as AudioPlayerBase } from '../../../../../contentObjects/widgets/Audio/Player';

export function AudioNode({ editor, node }: NodeViewProps) {
  const { alt, audioId, src } = node.attrs as { alt: string; audioId: string; src: string };

  return (
    <NodeViewWrapper as="span" className={classes.wrapper} contentEditable={false} data-testid="audio-button">
      {/* Inert while editing, matching the widget and carousel, whose Studio buttons also do not play.
          On an inner span so the node itself stays clickable for selection and deletion. */}
      <span className={classes.control} inert={editor.isEditable ? true : undefined}>
        <AudioPlayerBase
          classNames={{ placeholder: classes.placeholder, playButton: classes.playButton }}
          id={audioId}
          src={src}
          title={alt}
        />
      </span>
    </NodeViewWrapper>
  );
}
